module.exports = __webpack_public_path__ + "img/head_bg@2x.5a1e224b.png";